export default "__VITE_ASSET__D2VLs6ow__"